import { Block, Button, Text } from "../../components";
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";

const SuccessPurchasePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [orderId, setOrderId] = useState<string | null>(null);
    const [sessionId, setSessionId] = useState<string | null>(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const orderIdParam = searchParams.get("orderId");
        const sessionIdParam = searchParams.get("sessionId");

        if (orderIdParam) setOrderId(orderIdParam);
        if (sessionIdParam) setSessionId(sessionIdParam);

        if (orderIdParam || sessionIdParam) {
            console.log(sessionIdParam, orderIdParam);
            navigate(location.pathname, { replace: true });
        }
    }, [location, navigate]);

    return (
        <Block 
            display="flex" 
            direction="column"
            justify="center" 
            align="center" 
            mt="l"
        >
            <Text 
                as="h2"
                fontFamily="title"
                weight="bold"
                mb="l"
            >
                ¡Gracias por tu compra!
            </Text>
            <Button
                variant="icon" 
                iconSize="l" 
                icon="checkSuccess"
                mb="l"
                iconColor="green"
            />
            <Text as="h3" mb="l">
                Tu pedido ha sido realizado con éxito
            </Text>
            <Text mb="l">
                Pronto recibirás un correo con los detalles de tu pedido.
            </Text>
            <Text mb="l">
                ¿Quieres ver más accesorios únicos?
            </Text>
            <Button
                text="Seguir Comprando"
                variant="contained" 
                size="m" 
                color="earth"
                onClick={() => navigate('/')}
                mb="l"
            />
        </Block>
    );
};

export default SuccessPurchasePage;
